import axios from "axios";
import { notifyApiError } from '../errors/notifyApiError';

export const client = axios.create({
  baseURL: window.runConfig ? window.runConfig.REACT_APP_API_URL : window.location.origin + '/api',
  withCredentials: true
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const skipToast = error.config && error.config.skipErrorToast;
    const isAuthFailure = status === 401 || status === 403;
    const isCanceled = axios.isCancel && axios.isCancel(error);

    if (!skipToast && !isAuthFailure && !isCanceled) {
      notifyApiError(error);
    }

    return Promise.reject(error);
  }
);
